import { render, staticRenderFns } from "./posCheckIndex.vue?vue&type=template&id=2550a6ea&"
import script from "./posCheckIndex.vue?vue&type=script&lang=js&"
export * from "./posCheckIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports